<svg [id]="'bubble-map-' + id" [attr.width]="rzWidth || 630" [attr.height]="rzHeight || 410"></svg>
<ano-loader [isOpen]="loading"></ano-loader>
